import request from '../../plugins/request'

//获取作者收入
export function getIncomeList(data) {
  return request({
    url: '/api/AuthorReport/GetIncomeList',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_BASE_API}`
  })
}

export function getIncomeSum(data) {
  return request({
    url: '/api/AuthorReport/GetIncomeSum',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_BASE_API}`
  })
}
//获取可提现金额
export function getAuthorCashOutAmount(data) {
  return request({
    url: '/api/AuthorCashOutDetail/GetAuthorCashOutAmount',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_BASE_API}`
  })
}
//添加或更新提现记录(存在则更新)
export function addAuthorCashOutDetail(data) {
  return request({
    url: '/api/AuthorCashOutDetail/AddAuthorCashOutDetail',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_BASE_API}`
  })
}
//看看提现记录
export function getAuthorCashOutDetailList(data) {
  return request({
    url: '/api/AuthorCashOutDetail/GetAuthorCashOutDetailList',
    method: 'post',
    data,
    baseURL: `${process.env.VUE_APP_BASE_API}`
  })
}

//收入概览
export function apiGetIncomeSummary(data) {
  return request({
    url: '/api/AuthorReport/GetIncomeSummary',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

//获取书籍月明细数据
export function apiGetIncomeDetailByMonth(data) {
  return request({
    url: '/api/AuthorReport/GetIncomeDetailByMonth',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

//获取书籍
export function apiGetAuthorWorksListone(data) {
  return request({
    url: '/api/AuthorWorks/GetAuthorWorksList',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

//每日消耗书币记录
export function apiGetIncomeDailyDetail(data) {
  return request({
    url: '/api/AuthorReport/GetIncomeDailyDetail',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

//账户审核
export function GetAuthorBankList(data){
  return request(
  {
    url:'/api/AuthorBankInfo/GetAuthorBankList',
    method:'post',
    data
  })
}

//添加银行账户信息
export function AddAuthorBankInfo(data){
  return request(
  {
    url:'/api/AuthorBankInfo/AddAuthorBankInfo',
    baseURL: process.env.VUE_APP_WRITERFUN_API,
    method:'post',
    data
  })
}

export function AddAuthorBankList(data){
  return request(
  {
    url:'/api/AuthorBankInfo/AddAuthorBankList',
    baseURL: process.env.VUE_APP_WRITERFUN_API,
    method:'post',
    data
  })
}

export function GetCashOutReview(data) {
	return request({
		url: '/api/AuthorCashOutReview/GetAuthorCashOutReviewById',
		method: 'post',
    baseURL: process.env.VUE_APP_WRITERFUN_API,
		data
	})
}